import { render, staticRenderFns } from "./rego-customer-select-account.vue?vue&type=template&id=5dc3de27&scoped=true&"
import script from "./rego-customer-select-account.vue?vue&type=script&lang=js&"
export * from "./rego-customer-select-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3de27",
  null
  
)

export default component.exports